import React, { createContext, useContext, useEffect, useState } from 'react';
import { strings } from '@/i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('itw_lang') || 'de');

  useEffect(() => {
    localStorage.setItem('itw_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const parts = key.split('.');
    let node = strings[lang];
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) return key;
    }
    return node;
  };

  const tv = (obj) => {
    if (obj && typeof obj === 'object' && (obj.de || obj.en)) return obj[lang] || obj.de;
    return obj;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tv }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
